import CityPageTemplate from "../city-template/CityPageTemplate";
import { westlandConfig } from "./data";

export default function WestlandPage() {
  return <CityPageTemplate config={westlandConfig} />;
}